import { memo } from 'react';
import { UploadedFile } from '@ui';
import { noop } from 'lodash-es';
import { useChannelFiles } from './useChannelFiles';
import { TabLoadingState } from '../components/TabLoadingState';
import { TabEmptyState } from '../components/TabEmptyState';

export const ChatFilesTab = memo(() => {
  const { files, isLoading } = useChannelFiles();

  if (isLoading) return <TabLoadingState />;
  if (files.length === 0) return <TabEmptyState message="No files yet" />;

  return (
    <div className="flex flex-col gap-2">
      {files.map((file) => (
        <UploadedFile
          key={file.id}
          file={{
            id: file.id,
            fileName: file.fileName,
            path: file.url,
            signedUrl: file.url,
          }}
          showDownloadBtn
          onDelete={noop}
          containerClassName="bg-base-80"
        />
      ))}
    </div>
  );
});
